module.exports = __webpack_public_path__ + "img/manage-talent.bcd40aa1.svg";